import axios from "axios";
import { BrevoApiKey, SenderEmail, SenderEmailcustomer, SenderEmailcustomerTo, SenderName } from "./utils";

const SendAskAwayEmail = async (formData) => {
  //  <img src="https://kozestays.com/images/form_logo.png" alt="Logo" style="display: block; margin: 0 auto; width: 150px; height: auto;">

  const htmlContent = `
  <html lang="en">
  <head>
      <style>
         body {
              font-family: Optima;
              background-color: #000;
              color: #E7D5B1;
              margin: 0;
              padding: 0;
          }
          .container {
              width: 90%;
              max-width: 800px;
              margin: auto;
              background-color: #000;
              padding: 20px;
              box-shadow: 0 0 10px rgba(0, 0, 0, 0.5);
          }
          table {
              width: 100%;
              border-collapse: collapse;
              margin-bottom: 20px;
              background-color: #000; 
          }
          th, td {
              text-align: left;
              border: 0.5px solid #fff;
              padding: 10px;
              font-size: 12px; color: #E7D5B1;
          }
          td{
           color: #E7D5B1;
           }
          th {
              background-color: #000;
              color: #fff;
              font-weight: bold;
              width:30%;
          }
               h1 {
              color: #fff; 
              font-family: Optima; 
              text-align: center;
             font-size: 23px;
          }
      </style>
  </head>
  <body>
      <div class="container">
          <table>
       
       <h1>Hi, New Ask Away Inquiry from ${formData?.email}</h1>
          <table>
              <tr>
                  <th>Name</th>
                  <td>${formData?.name}</td>
              </tr>
               <tr>
                  <th>Email</th>
                 <td>${formData?.email}</td>
              </tr>
              <tr>
                  <th>Subject</th>
                    <td>${formData?.subject}</td>
              </tr>
               <tr>
                  <th>Phone No.</th>
                    <td>${formData?.phone}</td>
              </tr>
               <tr>
                  <th>Message</th>
                   <td>${formData?.message}</td>
              </tr>
          </table>
       </table>
      </div>
  </body>
  </html>`;

  const sendAdminData = {
    sender: {
      name: SenderName,
      email: SenderEmailcustomer,
    },
    to: [
      {
        email: SenderEmailcustomerTo,
        name: "KhouryCapital",
      },
    ],
    cc: [
      {
        email: SenderEmail,
      },
    ],
    subject: `New Ask Away Request Submitted: ${formData?.email}`,
    htmlContent: htmlContent,
  };

  const userData = {
    sender: {
      name: SenderName,

      email: SenderEmailcustomer,
    },
    to: [
      {
        email: formData?.email,
        name: formData?.name,
      },
    ],
    subject: "Confirmation of Ask Away Submission and Request Received",
    htmlContent,
  };
  try {

    const response = await axios.post(
      process.env.REACT_APP_SMTP_EMAIL,
      sendAdminData,
      {
        headers: {
          accept: "application/json",
          "api-key": BrevoApiKey,
          "content-type": "application/json",
        },
      }
    );

    await axios.post(
      process.env.REACT_APP_SMTP_EMAIL,
      userData,
      {
        headers: {
          accept: "application/json",
          "api-key": BrevoApiKey,
          "content-type": "application/json",
        },
      }
    );
    return response.data;
  } catch (error) {

    console.error("Error sending email:", error);
    throw error;
  }
};

export default SendAskAwayEmail;
